export default __webpack_public_path__ + "static/media/Snd_LowerGBackdown.b80af44e.mp3";